// 定义所需的 mutations
const mutations = {
  DYNAMIC(state, companyDynamic) {
    state.newsOnline.companyDynamic = companyDynamic
  },
  DYNAMICIMG(state, companyDynamicImg) {
    state.newsOnline.companyDynamicImg = companyDynamicImg
  },
  DTOTAL(state, dynamicTotal) {
    state.newsOnline.dynamicTotal = dynamicTotal
  },
  REPORT(state, mediaReport) {
    state.newsOnline.mediaReport = mediaReport
  },
  REPORTIMG(state, mediaReportImg) {
    state.newsOnline.mediaReportImg = mediaReportImg
  },
  RTOTAL(state, reportTotal) {
    state.newsOnline.reportTotal = reportTotal
  },
  BENEFIT(state, socialBenefit) {
    state.socialBenefit  = socialBenefit
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js